export default "/images/si-img3.jpg?38bebc7dfdc8241c03e0fd10dac6fe69";